export const StimulusDocumentViewerController = function () {};
